import { AxiosInstance } from "axios"

export type GenesisCareFakeDatabaseRecord = {
	recordDate: string
	recordId: string
	recordContent: any
}

export class GenesisCareEchoClient {
    constructor(private axiosInstance: AxiosInstance) {}

    private base = "/manage/genesiscare/integration"

    private jsonParseOrRaw = (input: string) => {
		try {
			return JSON.parse(input)
		} catch (e) {
			console.warn("Unable to parse input", { input, e })
			return input
		}
	}

    public add = (newRecords: string) => {
        const recordsJson = this.jsonParseOrRaw(newRecords)

        return this.axiosInstance.put<void>(
            `${this.base}/add`,
            recordsJson
        )
    }

	public clear = () =>
		this.axiosInstance.delete(`${this.base}/clear`)

    public records = () => {
		return this.axiosInstance.get<GenesisCareFakeDatabaseRecord[]>(
			`${this.base}/records`
		)
	}
}
